import type { Dict } from '../types';
import { en } from './en';

export const ja: Dict = {
  ...en,
  'workingDirPicker.title': "Folder",
  'workingDirPicker.homeTitle': "Choose where this project should live",
  'workingDirPicker.processing': "Processing…",
  'workingDirPicker.select': "Choose working directory",
  'workingDirPicker.clearAria': "Clear working directory",
  'workingDirPicker.replaceFailed': "Could not replace working directory",
  'workingDirPicker.unavailable': "Folder picker is unavailable in this build. Run the desktop app to pick a folder.",
  'workingDirPicker.openUnavailable': "Open this project in the desktop app to show the folder.",
  'workingDirPicker.openFailed': "Could not show this folder",
  'workingDirPicker.showInFileManager': "Show in file manager",
  'workingDirPicker.replace': "Clear and replace directory…",
  'workingDirPicker.recent': "Recent directories",
  'handoff.toTarget': 'Hand off to {target}',
  'handoff.action': 'Hand off',
  'handoff.fallbackTitle': 'No editors found on $PATH - opens in {target}',
  'handoff.chooseTargetAria': 'Choose hand-off target',
  'handoff.notInstalled': 'Not installed',
  'handoff.notDetectedTitle': '{target} - not detected on $PATH',
  'homeHero.promptExamples': "例",
  'homeHero.footer.designSystem': "スタイル",
  'homeHero.footer.autoDesignSystem': "自動",
  'homeHero.footer.autoDesignSystemSummary': "現在のプロンプトに最適なデザインシステムと視覚スタイルを自動で選びます。",
  'homeHero.footer.ratio': "比率",
  'homeHero.footer.duration': "長さ",
  'homeHero.footer.resolution': "解像度",
  'homeHero.footer.speakerNotes': "Notes",
  'homeHero.footer.noSpeakerNotes': "ノートなし",
  'homeHero.footer.availableCount': "{n} available",
  'homeHero.footer.noMatches': "No matches",
  'homeHero.moreShortcuts': "その他",
  'common.cancel': 'キャンセル',
  'common.save': '保存',
  'common.close': '閉じる',
  'common.delete': '削除',
  'common.rename': '名前を変更',
  'common.edit': '編集',
  'common.preview': 'プレビュー',
  'common.share': '共有',
  'common.search': '検索',
  'common.searchEllipsis': '検索…',
  'common.loading': '読み込み中…',
  'common.all': 'すべて',
  'common.none': 'なし',
  'common.default': 'デフォルト',
  'common.installed': 'インストール済み',
  'common.notInstalled': '未インストール',
  'common.active': 'アクティブ',
  'common.offline': 'オフライン',
  'common.selected': '選択中',
  'common.create': '作成',
  'common.openPreview': 'プレビューを開く',
  'common.exitFullscreen': 'フルスクリーンを終了',
  'common.fullscreen': 'フルスクリーン',
  'common.openInNewTab': '新しいタブで開く',
  'common.exportPdf': 'PDFとしてエクスポート',
  'common.exportZip': '.zipとしてダウンロード',
  'common.exportHtml': 'スタンドアロンHTMLとしてエクスポート',
  'common.justNow': 'たった今',
  'common.minutesAgo': '{n}分前',
  'common.hoursAgo': '{n}時間前',
  'common.daysAgo': '{n}日前',
  'common.weeksAgo': '{n}w ago',
  'common.now': '今',
  'common.minutesShort': '{n}分',
  'common.hoursShort': '{n}時間',
  'common.daysShort': '{n}日',
  'common.untitled': '無題',

  'app.brand': 'Open Design',
  'app.brandPill': 'リサーチプレビュー',
  'app.brandSubtitle': 'by Nexu Labs',
  'app.welcomeLoading': 'ワークスペースを読み込み中…',

  'settings.welcomeKicker': "",
  'settings.welcomeTitle': "Welcome",
  'settings.welcomeSubtitle': "",
  'settings.onboardingCreateTitle': 'Start from a brief',
  'settings.onboardingCreateBody':
    'Describe the site, app, deck, image, or video you want. Open Design will create a project and keep the work editable.',
  'settings.onboardingMemoryTitle': 'Save working context',
  'settings.onboardingMemoryBody':
    'Add preferences, project facts, and recurring rules so future chats pick up the right context.',
  'settings.onboardingSystemsTitle': 'Bring your design system',
  'settings.onboardingSystemsBody':
    'Pick or create a brand system so generated work follows real colors, typography, and product language.',
  'settings.onboardingExecutionTitle': 'Choose how generation runs',
  'settings.onboardingExecutionBody':
    'Use a local CLI agent or connect your own API key. You can change this any time in Settings.',
  'settings.onboardingStepConnect': "Connect",
  'settings.onboardingStepDesignSystem': "Design system",
  'settings.onboardingStepProfile': "About you",
  'settings.onboardingConnectTitle': "Choose a runtime",
  'settings.onboardingConnectBody': "",
  'settings.onboardingRecommended': "Recommended",
  'settings.onboardingLocalTitle': "Local coding agent",
  'settings.onboardingLocalBody': "Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.",
  'settings.onboardingLocalAction': "Open CLI settings",
  'settings.onboardingCliScanHint': "This usually takes 5-10 seconds.",
  'settings.onboardingByokTitle': "Bring your own key",
  'settings.onboardingByokBody': "Use your own model provider credentials.",
  'settings.onboardingByokAction': "Open BYOK settings",
  'settings.onboardingDesignTitle': "Design system",
  'settings.onboardingDesignBody': "Generate once, reuse everywhere.",
  'settings.onboardingDesignIntroGenerateTitle': "Generate from existing work",
  'settings.onboardingDesignIntroGenerateBody': "Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.",
  'settings.onboardingDesignIntroReuseTitle': "Reuse in future work",
  'settings.onboardingDesignIntroReuseBody': "Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.",
  'settings.onboardingDesignIntroSkipTitle': "Optional for now",
  'settings.onboardingDesignIntroSkipBody': "Skip this step if you want to start without generating a design system.",
  'settings.onboardingGithubTitle': "Import from GitHub",
  'settings.onboardingGithubBody': "Use a frontend repository.",
  'settings.onboardingUploadTitle': "Upload local files",
  'settings.onboardingUploadBody': "Add project files, screenshots, CSS, docs, or assets.",
  'settings.onboardingPromptTitle': "Generate from prompt",
  'settings.onboardingPromptBody': "Describe the product or brand.",
  'settings.onboardingProfileTitle': "About you",
  'settings.onboardingProfileBody': "Optional details for better defaults.",
  'settings.onboardingRoleLabel': "Your role",
  'settings.onboardingOrgSizeLabel': "Organization size",
  'settings.onboardingUseCaseLabel': "Use case",
  'settings.onboardingSourceLabel': "Where did you hear about us?",
  'settings.onboardingSelectPlaceholder': "Select one",
  'settings.onboardingSelectMultiplePlaceholder': "Select one or more",
  'settings.onboardingOrgSolo': "Solo / personal (1)",
  'settings.onboardingOrgTeam': "Small team (2-10)",
  'settings.onboardingOrgStartup': "Startup / SMB (11-50)",
  'settings.onboardingOrgGrowth': "Growth company (51-200)",
  'settings.onboardingOrgMidMarket': "Mid-market (201-1000)",
  'settings.onboardingOrgEnterprise': "Enterprise (1000+)",
  'settings.onboardingRolePm': "📋 Product manager",
  'settings.onboardingRoleDesigner': "🎨 Designer",
  'settings.onboardingRoleEngineer': "💻 Engineer",
  'settings.onboardingRoleMarketing': "📣 Marketing",
  'settings.onboardingRoleGrowth': "📈 Growth",
  'settings.onboardingRoleOps': "⚙️ Operations",
  'settings.onboardingRoleFounder': "🚀 Founder / executive",
  'settings.onboardingRoleStudent': "🎓 Student / educator",
  'settings.onboardingRoleOther': "✨ Other",
  'settings.onboardingUseProduct': "🎨 Product design",
  'settings.onboardingUseDesignSystem': "🧩 Design system",
  'settings.onboardingUsePrototype': "📱 Prototype / app UI",
  'settings.onboardingUseLanding': "🌐 Landing pages",
  'settings.onboardingUseAds': "📣 Ads / social content",
  'settings.onboardingUseDashboard': "📊 Dashboards / internal tools",
  'settings.onboardingUseDeck': "🖥️ Presentation / deck",
  'settings.onboardingUseMarketing': "📈 Marketing / growth",
  'settings.onboardingUseEngineering': "🤝 Engineering handoff",
  'settings.onboardingUseAgency': "💼 Agency / client work",
  'settings.onboardingSourceGithub': "🐙 GitHub",
  'settings.onboardingSourceFriend': "👥 Friend or coworker",
  'settings.onboardingSourceSocial': "📱 Social media",
  'settings.onboardingSourceProductHunt': "🅿️ Product Hunt",
  'settings.onboardingSourceCommunity': "💬 Design / AI community",
  'settings.onboardingSourceYoutube': "▶️ YouTube",
  'settings.onboardingSourceBlog': "📰 Blog or newsletter",
  'settings.onboardingSourceAiTool': "✨ AI tool recommendation",
  'settings.onboardingSourceSearch': "🔍 Search",
  'settings.onboardingSourceEvent': "🎤 Event or community",
  'settings.onboardingBack': "Back",
  'settings.onboardingContinue': "Continue",
  'settings.onboardingFinish': "Finish setup",
  'settings.onboardingSkip': "Skip for now",
  'settings.kicker': '設定',
  'settings.title': '実行モード',
  'settings.subtitle': 'ローカル CLI と BYOK のどちらを使うか選択します。',
  'settings.modeAria': '実行モード',
  'settings.protocolAria': 'API プロトコル',
  'settings.modeDaemon': 'ローカル CLI',
  'settings.modeDaemonHelp': 'マシン上のコードエージェント CLI 経由で実行',
  'settings.modeDaemonOffline': 'デーモンが起動していません',
  'settings.modeDaemonOfflineMeta': 'デーモンオフライン',
  'settings.modeDaemonInstalledMeta': '{count} インストール済み',
  'settings.modeApi': 'API プロバイダー',
  'settings.modeApiMeta': 'BYOK',
  'settings.codeAgent': 'コードエージェント',
  'settings.codeAgentHint':
    'PATH をスキャンして検出されます。生成に使用する CLI を選択してください。',
  'settings.rescan': '↻ 再スキャン',
  'settings.rescanTitle': 'PATH を再スキャン',
  'settings.rescanRunning': 'スキャン中...',
  'settings.rescanSuccess': 'スキャン完了。{count} 件が利用可能です。',
  'settings.designSystemRenameFailed': '名前の変更に失敗しました。デーモンを確認して再試行してください。',
  'settings.rescanFailed': 'スキャンに失敗しました。デーモンを確認して再試行してください。',
  'settings.test': 'テスト',
  'settings.testTitle': '接続を確認するため、ごく短いテストプロンプトを送信します',
  'settings.testRunning': '接続をテスト中…',
  'settings.testCancel': 'キャンセル',
  'settings.testSuccessApi': '接続成功。{ms} ms で応答 — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} が {ms} ms で応答 — \'{sample}\'',
  'settings.testAuthFailed': '認証に失敗しました。API キーを確認してください。',
  'settings.testForbidden': 'アクセスが拒否されました。アカウント、リージョン、組織を確認してください。',
  'settings.testNotFoundModel': 'このエンドポイントにモデル \'{model}\' は見つかりません。',
  'settings.testInvalidModelId': 'モデル ID \'{model}\' は無効です。カスタム ID は英数字で始まり、空白を含めないでください。',
  'settings.testInvalidBaseUrl': 'Base URL が無効か到達できません。',
  'settings.testRateLimited': 'プロバイダがテストをレート制限しました。設定は有効に見えます。',
  'settings.testUpstream': 'プロバイダが {status} を返しました。少し時間をおいて再試行してください。',
  'settings.testTimeout': '{ms} ms 後にテストがタイムアウトしました。',
  'settings.testAgentMissing': '{agentName} がインストールされていないか、PATH にありません。',
  'settings.testAgentSpawn': '{agentName} を起動できませんでした: {detail}。',
  'settings.testUnknown': 'テストに失敗しました: {detail}',
  'settings.agentInstall.install': 'インストール',
  'settings.agentInstall.docs': 'ドキュメント',
  'settings.agentInstall.pathHint':
    'npm または Homebrew で CLI をインストールしたのに未インストールのまま表示される場合は、Open Design daemon が引き継ぐ PATH にツールの bin ディレクトリが含まれていることを確認してください（macOS では Terminal と GUI アプリで PATH が異なる場合があります）。QUICKSTART.md（"Local agent CLI and PATH" セクション）を参照してください。',
  'settings.agentInstall.stepOpenLinks': '利用したいエージェントの「インストール」または「ドキュメント」を開きます。',
  'settings.agentInstall.stepAuth':
    'Open Design に戻る前に、ベンダー CLI で認証（サインインまたは API 資格情報の追加）を行います。',
  'settings.agentInstall.stepRescan': 'このセクションで「再スキャン」をクリックします。',
  'settings.agentInstall.stepSelect': 'インストール済みとして表示されたらエージェントカードを選択します。',
  'settings.noAgentsDetected':
    'エージェントが検出されませんでした。Claude Code、Codex、Gemini CLI、OpenCode、Cursor Agent、Qwen、または GitHub Copilot CLI のいずれかをインストールして、再スキャンをクリックしてください。',
  'settings.agentInstalledGroup': 'あなたの CLI（{count}）',
  'settings.agentInstallGroup': 'インストール可能（{count}）',
  'settings.agentAuthRequired': '認証が必要です',
  'settings.agentAuthUnknown': '認証状態は不明です',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'プロバイダーをクイック入力',
  'settings.customProvider': 'カスタムプロバイダー',
  'settings.apiKey': 'APIキー',
  'settings.showKey': 'キーを表示',
  'settings.hideKey': 'キーを隠す',
  'settings.show': '表示',
  'settings.hide': '隠す',
  'settings.model': 'モデル',
  'settings.suggestedModelsHint':
    'これはこのプロトコル向けの推奨モデルです。プロバイダーによっては別のモデルをサポートしている場合があります。',
  'settings.baseUrl': 'ベース URL',
  'settings.baseUrlInvalid': '有効な公開 http:// または https:// URL を入力してください。localhost は許可され、プライベートネットワーク IP はブロックされます。',
  'settings.baseUrlCustomize': 'カスタマイズ',
  'settings.baseUrlDefaultHint': 'デフォルトのエンドポイントです。通常は変更不要です。',
  'settings.azureBaseUrlPlaceholder': 'https://my-resource.openai.azure.com',
  'settings.azureBaseUrlHint': 'Find this in Azure portal → your resource → Endpoint.',
  'settings.azureDeploymentModel': 'デプロイ名',
  'settings.azureDeploymentModelHint':
    'Azure OpenAI では、このフィールドが /openai/deployments/<model> のデプロイ名として使われます。Azure で作成したデプロイ名を入力してください。',
  'settings.apiVersion': 'API バージョン',
  'settings.byokImageModel': '画像生成モデル',
  'settings.maxTokens': '最大トークン（任意）',
  'settings.maxTokensHint':
    '応答長の上限。各モデルにチューニング済みのデフォルト値があります（プレースホルダーに表示）。空のままにすればそれを使用し、数値を入力すれば上書きされます。',
  'settings.apiHint': 'リクエストはローカル daemon プロキシ経由で設定した Base URL に送信されます。キーはこのブラウザ内にのみ保存され、プロバイダーへのリクエスト時に送信されます。',
  'settings.skipForNow': '今はスキップ',
  'settings.getStarted': '始める',
  'settings.envConfigure': '実行モード',
  'settings.localCli': 'ローカル CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'エージェント未選択',
  'settings.language': '言語',
  'settings.languageHint': 'インターフェースの言語を切り替えます。このブラウザに保存されます。',
  'settings.appearance': '外観',
  'settings.appearanceHint': 'ライト、ダーク、またはシステム設定に従う。',
  'settings.themeSystem': 'システム',
  'settings.themeLight': 'ライト',
  'settings.themeDark': 'ダーク',
  'settings.agentModelHead': 'モデル：',
  'settings.modelPicker': 'モデル',
  'settings.modelSourceLive': 'CLI から取得',
  'settings.modelSourceFallback': '組み込みリスト',
  'settings.reasoningPicker': '推論の強さ',
  'settings.modelPickerHint':
    'CLI が `models` コマンドを公開している場合に取得されます。「デフォルト」は CLI 自身の設定に委ね、「カスタム…」は CLI が受け付ける任意のモデル ID を入力できます。',
  'settings.modelPickerLiveHint':
    'インストール済みの CLI からモデルを更新しました。デフォルトは引き続き CLI 設定を使用します。',
  'settings.modelPickerFallbackHint':
    '組み込みのデフォルトを表示しています。再スキャンをクリックすると CLI から最新モデルを取得します。',
  'settings.cliEnvTitle': 'CLI config locations',
  'settings.cliEnvHint':
    'Set non-secret config directories for packaged app runs and agent detection.',
  'settings.cliEnvClaudeConfigDir': 'Claude Code config directory',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude proxy API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex executable path',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI proxy API key',
  'settings.modelCustom': 'カスタム（下に入力）…',
  'settings.modelCustomLabel': 'カスタムモデル ID',
  'settings.modelCustomPlaceholder': '例: anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'メディアプロバイダー',
  'settings.mediaProvidersHint':
    '画像・動画・音声生成のための API キー。ローカルに保存され、ローカルデーモンに同期されます。',
  'settings.mcpServerTitle': 'MCP サーバー',
  'settings.mcpServerHint': 'Open Design を MCP サーバーとしてコーディングエージェントに公開します。',
  'settings.externalMcpTitle': '外部 MCP',
  'settings.externalMcpHint': '外部サービス（Higgsfield、GitHub など）の MCP ツールを追加します。',
  'settings.mediaProviderApiKey': 'APIキー',
  'settings.mediaProviderBaseUrl': 'ベース URL',
  'settings.mediaProviderConfigured': '設定済み',
  'settings.mediaProviderUnset': '未設定',
  'settings.mediaProviderClear': 'クリア',
  'settings.mediaProviderClearConfirm': '保存された {name} の設定を削除しますか？{name} を使うには再度入力する必要があります。',
  'settings.mediaProviderPlaceholder': 'APIキーを貼り付け',
  'settings.mediaProviderBaseUrlPlaceholder': 'デフォルトのベース URL を上書き',
  'settings.mediaProviderReload': 'デーモンから再読み込み',
  'settings.mediaProviderReloadError': 'ローカルデーモンからメディアプロバイダー設定を再読み込みできませんでした。',
  'settings.mediaProviderReloadSuccess': 'ローカルデーモンからメディアプロバイダー設定を再読み込みしました。',
  'settings.mediaProviderLoadError': 'ローカルデーモンからメディアプロバイダー設定を読み込めませんでした。今のところブラウザーに保存された設定を使用します。',
  'settings.mediaProviderComingSoonHint': 'これらはロードマップで追跡しています。デーモンはまだクライアントを提供していないため、設定するものはありません。',
  'settings.privacy': 'Privacy',
  'settings.privacyHint': 'What data is shared with the Open Design team',
  'settings.privacyConsentKicker': 'Help us improve Open Design',
  'settings.privacyConsentLead': 'Open Design can share usage data with our team to help us improve. This includes:',
  'settings.privacyConsentFooter': 'You can change either of these any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentShare': 'Share usage data',
  'settings.privacyConsentDecline': "Don't share",
  'settings.privacyConsentAccept': 'I get it',
  'settings.privacyConsentBannerFooter':
    'Data sharing is on by default. You can turn it off any time in Settings → Privacy. We never upload the contents of your generated artifact files.',
  'settings.privacyConsentPolicyLink': 'Read the privacy policy',
  'settings.privacyMetrics': 'Anonymous metrics',
  'settings.privacyMetricsHint': 'Run counts, token usage, error rate, duration. No prompts, no project data.',
  'settings.privacyContent': 'Conversation content',
  'settings.privacyContentHint': "Your prompts and the assistant's responses (truncated 8 KB / 16 KB). API keys, tokens, JWTs, emails, IPs, and credit-card numbers are stripped automatically before send.",
  'settings.privacyArtifacts': 'Project artifacts manifest',
  'settings.privacyArtifactsHint': 'Filenames, types, sizes of generated files. File contents are never sent.',
  'settings.privacyInstallationId': 'Anonymous ID',
  'settings.privacyOptedOut': 'opted out',
  'settings.privacyDataDeletion': 'Delete my data',
  'settings.privacyDataDeletionHint': 'Rotates your anonymous ID and stops sending. Existing traces age out under our retention policy.',
  'settings.about': 'About',
  'settings.aboutHint': 'バージョンと実行環境の詳細',
  'settings.appVersion': 'バージョン',
  'settings.appChannel': 'チャンネル',
  'settings.appRuntime': '実行環境',
  'settings.appPlatform': 'プラットフォーム',
  'settings.appArchitecture': 'アーキテクチャ',
  'settings.runtimePackaged': 'パッケージ版アプリ',
  'settings.runtimeDevelopment': '開発環境',
  'settings.versionUnavailable': 'daemon がオフラインの間はバージョン詳細を取得できません。',
  'settings.installLatest': '最新版をインストール',
  'settings.alreadyLatest': '最新バージョンです',

  'entry.tabDesigns': 'デザイン',
  'entry.tabTemplates': 'テンプレート',
  'entry.tabDesignSystems': 'デザインシステム',
  'entry.openSettingsTitle': '設定',
  'entry.openSettingsAria': '設定を開く',
  'entry.resizeAria': 'サイドバーをリサイズ',
  'entry.loadingWorkspace': 'ワークスペースを読み込み中…',
  'entry.useEverywhereTitle': 'どこでも使う',
  'entry.useEverywhereAria': '「どこでも使う」ガイドを開く（CLI、MCP、HTTP、Skills）',
  'entry.navNewProject': '新規プロジェクト',
  'entry.navHome': 'ホーム',
  'entry.navProjects': 'プロジェクト',
  'entry.navDesignSystems': 'デザインシステム',
  'entry.helpAria': 'ヘルプ',
  'entry.helpMenuAria': 'ヘルプメニュー',
  'entry.helpGetHelp': 'GitHub でサポートを受ける',
  'entry.helpSubmitFeature': '機能をリクエスト',
  'entry.helpWhatsNew': '最新情報',
  'entry.helpDownloadDesktop': 'デスクトップアプリをダウンロード',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': 'GitHub でスターを付ける',
  'entry.githubStarAria': 'GitHub で Open Design にスターを付ける',
  'entry.tabImageTemplates': '画像テンプレート',
  'entry.tabVideoTemplates': '動画テンプレート',
  'promptTemplates.searchPlaceholder': 'テンプレートを検索…',
  'promptTemplates.countLabel': '{n} 件',
  'promptTemplates.emptyImage': '画像プロンプトテンプレートがまだインストールされていません。',
  'promptTemplates.emptyVideo': '動画プロンプトテンプレートがまだインストールされていません。',
  'promptTemplates.emptyNoMatch': '検索に一致するテンプレートがありません。',
  'promptTemplates.attributionFooter': '公開プロンプトライブラリから引用。各カードは元の作者にリンクしています。',
  'promptTemplates.openPreviewTitle': 'プロンプトとプレビューを開く',
  'promptTemplates.sourcePrefix': 'ソース:',
  'promptTemplates.fetchError': 'テンプレートの本文を読み込めませんでした。',
  'promptTemplates.promptLabel': 'プロンプト本文',
  'promptTemplates.copyPrompt': 'プロンプトをコピー',
  'promptTemplates.copyDone': 'コピーしました！',
  'promptTemplates.modelHint': '推奨モデル: {model}',
  'promptTemplates.openSource': 'オリジナルを表示',
  'promptTemplates.openFullscreen': 'フルスクリーンプレビューを開く',
  'promptTemplates.closeFullscreen': 'フルスクリーンプレビューを閉じる',
  'promptTemplates.allSources': 'すべてのソース',
  'promptTemplates.sourceFilterAria': 'ソースで絞り込む',
  'promptTemplates.retry': '再試行',

  'newproj.tabPrototype': 'プロトタイプ',
  'newproj.tabDeck': 'スライド',
  'newproj.tabTemplate': 'テンプレートから',
  'newproj.tabMedia': 'メディア',
  'newproj.tabOther': 'その他',
  'newproj.titlePrototype': '新しいプロトタイプ',
  'newproj.titleDeck': '新しいスライドデッキ',
  'newproj.titleTemplate': 'テンプレートから開始',
  'newproj.titleImage': '新しい画像',
  'newproj.titleVideo': '新しい動画',
  'newproj.titleAudio': '新しい音声',
  'newproj.titleMedia': '新しいメディア',
  'newproj.titleOther': '新しいプロジェクト',
  'newproj.namePlaceholder': 'プロジェクト名',
  'newproj.fidelityLabel': '品質',
  'newproj.fidelityWireframe': 'ワイヤーフレーム',
  'newproj.fidelityHigh': '高品質',
  'newproj.toggleSpeakerNotes': 'スピーカーノートを使用',
  'newproj.toggleSpeakerNotesHint': 'スライドのテキストを減らし、話す内容をノートに残します。',
  'newproj.toggleAnimations': 'アニメーションを含める',
  'newproj.toggleAnimationsHint':
    'テンプレートにモーション（入場・ホバー・トランジション）を追加します。',
  'newproj.templateLabel': 'テンプレート',
  'newproj.noTemplatesTitle': 'テンプレートがまだありません',
  'newproj.noTemplatesBody':
    'プロジェクトを開き、ファイルビューア内の共有メニューからテンプレートに変換してください。テンプレートはここに表示されます。',
  'newproj.savedTemplate': '保存済みテンプレート',
  'newproj.fileSingular': 'ファイル',
  'newproj.filePlural': 'ファイル',
  'newproj.create': '作成',
  'newproj.createFromTemplate': 'テンプレートから作成',
  'newproj.createDisabledTitle':
    '最初にプロジェクトをテンプレートとして保存してください（プロジェクト内の共有メニュー）。',
  'newproj.importClaudeZip': 'Claude Design ZIP をインポート',
  'newproj.importClaudeZipTitle': 'Claude Design の .zip エクスポートをインポート',
  'newproj.importingClaudeZip': 'インポート中…',
  'newproj.privacyFooter': 'デフォルトではあなただけがプロジェクトを見ることができます。',
  'newproj.designSystem': 'デザインシステム',
  'newproj.dsNoneFreeform': 'なし — フリーフォーム',
  'newproj.dsNoneSubtitleEmpty': 'システムトークンなし、独自のパレットを選択',
  'newproj.dsNoneSubtitleSelected': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsCategoryFallback': 'デザインシステム',
  'newproj.dsSearch': 'デザインシステムを検索…',
  'newproj.dsModeAria': '選択モード',
  'newproj.dsModeSingle': 'シングル',
  'newproj.dsModeMulti': 'マルチ',
  'newproj.dsNoneTitle': 'なし — フリーフォーム',
  'newproj.dsNoneSub': 'システムトークンをスキップ。エージェントが独自のパレットを選択します。',
  'newproj.dsEmpty': '"{query}" に一致するデザインシステムがありません。',
  'newproj.dsFootSingular': 'はインスピレーションのみです。',
  'newproj.dsFootPlural': 'はインスピレーションのみです。',
  'newproj.dsFootClear': 'クリア',
  'newproj.dsBadgeDefault': 'デフォルト',
  'newproj.dsPrimaryFallback': 'プライマリ',
  'newproj.surfaceImage': '画像',
  'newproj.surfaceVideo': '動画',
  'newproj.surfaceAudio': '音声',
  'newproj.modelLabel': 'モデル',
  'newproj.modelSearch': 'モデルを検索…',
  'newproj.modelEmpty': '一致するモデルがありません。',
  'newproj.modelRecommended': '推奨',
  'newproj.modelMissingTitle': 'モデルを選択',
  'newproj.modelMissingSub': 'このサーフェスに使うモデルを選択します。',
  'newproj.aspectLabel': 'アスペクト',
  'newproj.videoLengthLabel': '長さ',
  'newproj.videoLengthSeconds': '{n}秒',
  'newproj.audioKindLabel': '音声タイプ',
  'newproj.audioKindMusic': '音楽',
  'newproj.audioKindSpeech': 'スピーチ / TTS',
  'newproj.audioKindSfx': '効果音',
  'newproj.audioDurationLabel': '長さ',
  'newproj.audioDurationSeconds': '{n}秒',
  'newproj.voiceLabel': '音声',
  'newproj.voicePlaceholder': 'プロバイダーの音声 ID（省略可）',
  'newproj.promptTemplateLabel': '参照テンプレート',
  'newproj.promptTemplateNoneTitle': 'なし — 自分で書く',
  'newproj.promptTemplateNoneSub': 'ギャラリーをスキップして、自分でブリーフを書きます',
  'newproj.promptTemplateRefSub': '参照テンプレート',
  'newproj.promptTemplateSearch': 'テンプレートを検索…',
  'newproj.promptTemplateEmpty': 'この種類のテンプレートはまだインストールされていません。',
  'newproj.promptTemplateBodyLabel': 'プロンプト（編集可能）',
  'newproj.promptTemplateOptimizeHint':
    '自由に編集できます — 変更内容はエージェントのブリーフに反映されます。',
  'newproj.promptTemplateBodyEmpty': '本文が空です — エージェントはテンプレート参照を受け取りません。',

  'newproj.deleteTemplateTitle': 'テンプレートを削除',
  'newproj.deleteTemplateConfirm': '"{name}" を削除しますか？この操作は取り消せません。',
  'newproj.deleteTemplateConfirmCta': 'テンプレートを削除',
  'newproj.deleteTemplateError':
    'テンプレートを削除できませんでした。もう一度お試しください。',
  'designs.subRecent': '最近',
  'designs.subYours': 'あなたのデザイン',
  'designs.filterAria': 'プロジェクトをフィルター',
  'designs.searchPlaceholder': '検索…',
  'designs.emptyNoProjects': 'プロジェクトがまだありません。左側で作成してください。',
  'designs.emptyNoMatch': '検索に一致するプロジェクトがありません。',
  'designs.deleteTitle': 'プロジェクトを削除',
  'designs.deleteConfirm': '"{name}" を削除しますか？',
  'designs.cardFreeform': 'フリーフォーム',
  'designs.status.notStarted': '未開始',
  'designs.status.queued': 'キュー中',
  'designs.status.running': '実行中',
  'designs.status.awaitingInput': '入力待ち',
  'designs.status.succeeded': '完了',
  'designs.status.published': '公開済み',
  'designs.status.failed': '失敗',
  'designs.status.canceled': 'キャンセル済み',
  'designs.viewToggleAria': '表示モード',
  'designs.viewGrid': 'グリッド表示',
  'designs.viewKanban': 'ボード表示',
  'designs.kanbanEmptyColumn': 'デザインなし',
  'designs.deleteAria': 'プロジェクト {name} を削除',
  'designs.menuMore': 'More actions',
  'designs.menuRename': 'Rename',
  'designs.menuDelete': 'Delete',
  'designs.renamePrompt': 'New name for "{name}"',
  'designs.selectMode': 'Select',
  'designs.cancelSelect': 'Cancel',
  'designs.deleteSelected': 'Delete selected',
  'designs.selectedCount': '{n} selected',
  'designs.deleteSelectedConfirm': 'Delete {n} project(s)?',
  'designs.deleteSelectedSuccess': '{n} project(s) deleted successfully.',
  'designs.deleteSelectedPartial': 'Deleted {deleted} project(s); {failed} failed.',
  'designs.tagPrototype': 'Prototype',
  'designs.tagLiveArtifact': 'Live Artifact',
  'designs.tagSlide': 'Slide',
  'designs.tagMedia': 'Media',
  'designs.renameTitle': 'Rename project',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'Cancel',

  'examples.typeLabel': 'タイプ',
  'examples.surfaceLabel': 'サーフェス',
  'examples.surfaceWeb': 'Web',
  'examples.surfaceImage': '画像',
  'examples.surfaceVideo': '動画',
  'examples.surfaceAudio': '音声',
  'examples.scenarioLabel': 'シナリオ',
  'examples.modeAll': 'すべて',
  'examples.modePrototypeDesktop': 'プロトタイプ · デスクトップ',
  'examples.modePrototypeMobile': 'プロトタイプ · モバイル',
  'examples.modeDeck': 'スライド',
  'examples.modeDocument': 'ドキュメント & テンプレート',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'ライブ',
  'examples.scenarioGeneral': '一般',
  'examples.scenarioEngineering': 'エンジニアリング',
  'examples.scenarioProduct': 'プロダクト',
  'examples.scenarioDesign': 'デザイン',
  'examples.scenarioMarketing': 'マーケティング',
  'examples.scenarioSales': 'セールス',
  'examples.scenarioFinance': 'ファイナンス',
  'examples.scenarioHr': '人事',
  'examples.scenarioOperations': 'オペレーション',
  'examples.scenarioSupport': 'サポート',
  'examples.scenarioLegal': '法務',
  'examples.scenarioEducation': '教育',
  'examples.scenarioPersonal': '個人',
  'examples.emptyNoSkills': 'スキルがありません。デーモンは起動していますか？',
  'examples.searchPlaceholder': 'サンプルを検索…',
  'examples.searchAria': '名前でサンプルを検索',
  'examples.emptyNoMatch': 'このフィルターに一致するサンプルがありません。',
  'examples.openPreview': '⤢ プレビューを開く',
  'examples.loadingPreview': 'プレビューを読み込み中…',
  'examples.hoverPreview': 'ホバーでプレビュー',
  'examples.usePrompt': 'このプロンプトを使用',
  'examples.previewModalTitle': 'フルプレビューを開く（モーダル）',
  'examples.shareTitle': 'このサンプルを共有',
  'examples.shareLoadFirst': 'プレビューを読み込むためにホバーしてください',
  'examples.unavailablePlaceholder': '{kind} プレビューは同梱されていません — 詳細は開いて確認',
  'examples.shareUnavailable': '共有できる {kind} プレビューは同梱されていません',
  'examples.shareMenu': '共有 ▾',
  'examples.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'examples.exportPptxLocked': 'PPTXとしてエクスポート…（先にテンプレートを開いてください）',
  'examples.tagSlideDeck': 'スライドデッキ',
  'examples.tagTemplate': 'テンプレート',
  'examples.tagDesignSystem': 'デザインシステム',
  'examples.tagMobilePrototype': 'モバイルプロトタイプ',
  'examples.tagDesktopPrototype': 'デスクトッププロトタイプ',
  'examples.tagImage': '画像',
  'examples.tagVideo': '動画',
  'examples.tagAudio': '音声',
  'examples.previewLabel': 'プレビュー',

  'ds.surfaceLabel': 'サーフェス',
  'ds.surfaceWeb': 'Web',
  'ds.surfaceImage': '画像',
  'ds.surfaceVideo': '動画',
  'ds.surfaceAudio': '音声',
  'ds.searchPlaceholder': 'デザインシステムを検索…',
  'ds.emptyNoMatch': '検索に一致するデザインシステムがありません。',
  'ds.badgeDefault': 'デフォルト',
  'ds.preview': 'プレビュー',
  'ds.previewTitle': 'デザインシステムをプレビュー',
  'ds.categoryAll': 'すべて',
  'ds.categoryUncategorized': '未分類',
  'ds.showcase': 'ショーケース',
  'ds.tokens': 'トークン',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'DESIGN.md を読み込み中…',

  'avatar.title': 'アカウントと設定',
  'avatar.localCli': 'ローカル CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': 'ローカル CLI を使用',
  'avatar.useApi': 'API · BYOK を使用',
  'avatar.codeAgent': 'コードエージェント',
  'avatar.rescan': 'PATH を再スキャン',
  'avatar.settings': '設定',
  'avatar.backToProjects': 'プロジェクトに戻る',
  'avatar.metaActive': 'アクティブ',
  'avatar.metaOffline': 'オフライン',
  'avatar.metaSelected': '選択中',
  'avatar.noAgentSelected': 'エージェント未選択',
  'avatar.modelSection': 'モデル',
  'avatar.modelLabel': 'モデル',
  'avatar.reasoningLabel': '推論',
  'avatar.customSuffix': '（カスタム）',

  'inlineSwitcher.chipTitle': 'CLI / モデルを切り替え',
  'inlineSwitcher.chipCli': 'ローカル CLI',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'デフォルト',
  'inlineSwitcher.noAgent': 'エージェント未選択',
  'inlineSwitcher.modeLabel': 'モード',
  'inlineSwitcher.agentLabel': 'エージェント',
  'inlineSwitcher.providerLabel': 'プロバイダー',
  'inlineSwitcher.modelLabel': 'モデル',
  'inlineSwitcher.useCli': 'ローカル CLI を使用',
  'inlineSwitcher.useByok': '自分の API キーを使用',
  'inlineSwitcher.daemonOffline': 'デーモンがオフライン — 設定を開く',
  'inlineSwitcher.noAgentsDetected': 'PATH に CLI が見つかりません',
  'inlineSwitcher.openSettingsForModel': '設定でプロバイダーを構成してください',
  'inlineSwitcher.missingApiKey': 'API キー未設定 — 設定から追加してください。',
  'inlineSwitcher.openFullSettings': '実行設定を開く',
  'inlineSwitcher.customSuffix': '（カスタム）',

  'project.backToProjects': 'プロジェクトに戻る',
  'project.metaFreeform': 'フリーフォーム',
  'project.resizeChatPanel': 'チャットパネルのサイズを変更',
  'project.instructionsActive': '有効 — すべてのメッセージに含まれます',
  'chat.tabChat': 'チャット',
  'chat.tabComments': 'コメント',
  'chat.commentsSoon': 'コメント — 近日公開',
  'chat.comments.attached': 'Attached to chat',
  'chat.comments.emptyAttached': 'No comments attached.',
  'chat.comments.saved': 'Saved comments',
  'chat.comments.emptySaved': 'No saved comments.',
  'chat.comments.add': 'Add',
  'chat.comments.addAll': 'Add all',
  'chat.comments.remove': 'Remove',
  'chat.comments.placeholder': 'Comment on this element…',
  'chat.comments.addSend': 'Add & send',
  'chat.comments.updateSend': 'Update & send',
  'chat.comments.removeAttachment': 'Remove comment attachment',
  'chat.comments.removeAttachmentAria': 'Remove comment attachment for {name}',
  'chat.comments.comment': 'Comment',
  'chat.comments.sendToChat': 'Send to chat',
  'chat.comments.sending': 'Sending…',
  'chat.comments.edit': 'Edit',
  'chat.comments.select': 'Select',
  'chat.comments.deselect': 'Deselect',
  'chat.comments.nSelected': '{n} selected',
  'chat.comments.pin': 'Pin',
  'chat.comments.addNote': 'Add note',
  'chat.comments.savedToast': 'Comment saved',
  'chat.comments.pinSavedToast': 'Pin saved',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} captured items',
  'chat.comments.clear': 'Clear',
  'chat.inspect.noEditableTargets': 'This page has no editable elements yet.',
  'chat.inspect.noCommentTargets': 'This page has no commentable elements yet.',
  'chat.inspect.editHint': 'Click an element in the canvas to edit its styles.',
  'chat.inspect.commentHint': 'Click an element in the canvas to add a comment.',
  'chat.conversationsTitle': '会話',
  'chat.conversationsAria': '会話履歴',
  'chat.newConversation': '新しい会話',
  'chat.newConversationsTitle': '新しい会話',
  'chat.conversationsHeading': '会話',
  'chat.new': '新規',
  'chat.emptyConversations': 'まだ会話がありません。',
  'chat.deleteConversation': '会話を削除',
  'chat.renameConversationLabel': '「{title}」の名前を変更',
  'chat.deleteConversationConfirm':
    '"{title}" を削除しますか？メッセージも削除されます。',
  'chat.untitledConversation': '無題の会話',
  'chat.startTitle': '会話を始める',
  'chat.startHint': "生成したい内容を説明するか、以下の例から始めてください:",
  'chat.fillInputTitle': 'クリックして入力欄に入力',
  'chat.jumpToLatest': '最新にジャンプ',
  'chat.scrollToLatest': '最新にスクロール',
  'chat.you': 'あなた',
  'chat.openFile': '{name} を開く',
  'chat.copyPrompt': 'プロンプトをコピー',
  'chat.copyDone': 'コピーしました！',
  'chat.composerPlaceholder': "生成したい内容を説明してください…",
  'chat.composerHint': "⌘/Ctrl + Enter で送信 · 目的、内容、スタイル、形式を含める",
  'chat.cliSettingsTitle': 'CLI とモデルの設定',
  'chat.cliSettingsAria': 'CLI とモデルの設定を開く',
  'chat.attachTitle': 'ファイルを添付（または貼り付け / ドロップ）',
  'chat.attachAria': 'ファイルを添付',
  'chat.importTitle': 'ソースをインポート（近日公開）',
  'chat.importLabel': 'インポート',
  'chat.importComingSoon': '近日公開',
  'chat.importSoon': '近日',
  'chat.importFig': '.fig ファイルをアップロード',
  'chat.importGitHub': 'GitHub に接続',
  'chat.importWeb': 'Web 要素を取得',
  'chat.importFolder': 'コードフォルダーをリンク',
  'chat.importSkills': 'スキルとデザインシステム',
  'chat.importProject': 'Reference another project',
  'chat.linkedFolderRemoveAria': 'リンクされたフォルダー {path} を削除',
  'chat.linkedFolderNotFound': 'フォルダーが存在しません',
  'chat.linkedFolderAlready': 'このフォルダーは既にリンクされています',
  'chat.linkedFolderPickError': 'フォルダー選択を開けません',
  'chat.queuedHeader': 'Queued',
  'chat.queuedToSend': 'to Send',
  'chat.queuedEditQueuedTaskAria': 'Edit queued task',
  'chat.queuedSave': 'Save',
  'chat.queuedCancel': 'Cancel',
  'chat.queuedEdit': 'Edit',
  'chat.queuedMore': 'more queued',
  'chat.queuedFollowUpFallback': 'Queued follow-up',
  'chat.send': '送信',
  'chat.stop': '停止',
  'chat.removeAria': '{name} を削除',
  'chat.example1Title': '編集ピッチデッキ',
  'chat.example1Tag': '雑誌',
  'chat.example1Prompt':
    'シードラウンドを調達するデザインスタジオの10スライド編集ピッチデッキ — スイスグリッドレイアウト、大きなセリフ体の見出しにボールドドロップキャップ、等幅フォントのセクション番号、余白を活かしたデザイン、テキスト中心のスライドと交互に配置したフルブリード写真スライド。カバー、ビジョン、マーケット、プロダクト、トラクション、チーム、調達額、連絡先。',
  'chat.example2Title': 'SaaS 分析ダッシュボード',
  'chat.example2Tag': 'データ',
  'chat.example2Prompt':
    '開発者ツール SaaS の高密度な分析ダッシュボード — 前週比デルタ付き KPI ストリップ、積み上げ折れ線グラフ2本（MRR とアクティブワークスペース）、使用状況のワールドヒートマップ、コホートリテンショングリッド、トップ顧客リーダーボード、リアルタイムイベントフィード。ダークテーマ、表形式等幅数字、スパークラインアクセント。',
  'chat.example3Title': '年次報告書 長スクロール',
  'chat.example3Tag': '編集',
  'chat.example3Prompt':
    '気候系 NPO のインタラクティブ年次報告書 — 大きな引用ブロック、データビジュアライゼーション（積み上げ棒グラフ、アニメーションカウンター、プロジェクトサイトのコロプレスマップ）、写真ブレーカー、ドナーウォール、最後にコールトゥアクションを混在させた長スクロール編集レイアウト。モダンなセリフ体本文、サンセリフのチャートラベル、土のようなペーパーパレット。',

  'preview.shareMenu': '共有 ▾',
  'preview.openInNewTab': '新しいタブで開く',
  'preview.exit': '⤓ 終了',
  'preview.fullscreen': '⤢ フルスクリーン',
  'preview.closeTitle': '閉じる (Esc)',
  'preview.loading': '{label} を読み込み中…',
  'preview.errorTitle': 'この例を読み込めませんでした。',
  'preview.errorBody': '例の HTML を取得できませんでした。Open Design が起動していることを確認して再試行してください。',
  'preview.retry': '再試行',
  'preview.unavailableTitle': 'このスキルにはプレビューが同梱されていません。',
  'preview.unavailableBody': 'このスキルは {kind} 出力を生成します — チャットでプロンプトを実行して生成してください。',
  'preview.showSidebar': '{label} を表示',
  'preview.hideSidebar': '{label} を非表示',

  'misc.savedTemplate': '保存済みテンプレート',
  'misc.primary': 'プライマリ',
  'misc.designSystem': 'デザインシステム',

  'workspace.designFiles': 'デザインファイル',
  'workspace.focusMode': 'Focus workspace',
  'workspace.showChat': 'Show chat',
  'workspace.closeTab': 'タブを閉じる',
  'workspace.deleteFileConfirm': 'プロジェクトフォルダーから "{name}" を削除しますか？',
  'workspace.deleteSelectedFilesConfirm': 'プロジェクトフォルダーから選択した {n} 個のファイルを削除しますか？',
  'workspace.deleteSelectedFilesPartial': '{n} 個のファイルの削除に失敗しました。',
  'workspace.openFromDesignFiles': 'ファイルを開く: ',
  'workspace.designFilesLink': 'デザインファイル',
  'workspace.loadingSketch': 'スケッチを読み込み中…',
  'designFiles.title': 'デザインファイル',
  'designFiles.upload': 'ファイルをアップロード',
  'designFiles.pasteText': 'テキストファイルとして貼り付け',
  'designFiles.newSketch': '新しいスケッチ',
  'designFiles.empty': 'ここに作品が表示されます',
  'designFiles.refresh': '更新',
  'designFiles.delete': '削除',
  'designFiles.searchPlaceholder': 'ファイルを検索…',
  'designFiles.up': '上へ',
  'designFiles.back': '戻る',
  'designFiles.crumbs': 'プロジェクト',
  'designFiles.rowMenu': '行メニュー',
  'designFiles.openInTab': 'タブで開く',
  'designFiles.download': 'ダウンロード',
  'designFiles.downloadSelected': '{n}件をZIPとしてダウンロード',
  'designFiles.deleteSelected': '{n} 件を削除',
  'designFiles.clearSelection': '選択をクリア',
  'designFiles.selectPage': 'このページをすべて選択',
  'designFiles.selectAll': 'すべて選択',
  'designFiles.dropTitle': '⤓ ファイルをここにドロップ',
  'designFiles.dropDesc':
    '画像、ドキュメント、参考資料、フォルダー — エージェントがコンテキストとして使用します。',
  'designFiles.upload.title': 'ファイルをアップロード',
  'designFiles.paste.title': 'テキストをファイルとして貼り付け',
  'designFiles.upload.label': 'アップロード',
  'designFiles.paste.label': '貼り付け',
  'designFiles.previewOpen': '開く',
  'designFiles.previewClose': 'プレビューを閉じる',
  'designFiles.modified': '{time} に変更 · {size}',
  'designFiles.weeksAgo': '{n}週間前',
  'designFiles.groupBy': 'グループ化',
  'designFiles.groupByKind': '種類',
  'designFiles.groupByModified': '更新日時',
  'designFiles.expandGroup': '展開',
  'designFiles.collapseGroup': '折りたたむ',
  'designFiles.sectionPages': 'ページ',
  'designFiles.sectionScripts': 'スクリプト',
  'designFiles.sectionImages': '画像',
  'designFiles.sectionSketches': 'スケッチ',
  'designFiles.sectionOther': 'その他',
  'designFiles.modifiedToday': '今日',
  'designFiles.modifiedYesterday': '昨日',
  'designFiles.modifiedPrevious7Days': '過去7日間',
  'designFiles.modifiedPrevious30Days': '過去30日間',
  'designFiles.modifiedOlder': 'それ以前',
  'designFiles.showMore': 'さらに {n} 件表示',
  'designFiles.kindHtml': 'HTML ページ',
  'designFiles.kindImage': '画像',
  'designFiles.kindSketch': 'スケッチ',
  'designFiles.kindText': 'テキスト',
  'designFiles.kindCode': 'スクリプト',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'ドキュメント',
  'designFiles.kindPresentation': 'プレゼンテーション',
  'designFiles.kindSpreadsheet': 'スプレッドシート',
  'designFiles.kindBinary': 'バイナリ',
  'designFiles.kindFolder': 'フォルダ',
  'designFiles.folderCount': '{n} ファイル',
  'designFiles.colName': '名前',
  'designFiles.colKind': '種類',
  'designFiles.colModified': '更新日',
  'designFiles.perPage': '表示',
  'designFiles.all': 'すべて',
  'designFiles.prev': '前へ',
  'designFiles.next': '次へ',
  'designFiles.jumpToPage': 'ページにジャンプ',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'quickSwitcher.placeholder': 'ファイルを開く…',
  'quickSwitcher.empty': 'このプロジェクトにファイルがありません',
  'quickSwitcher.noMatches': '一致なし',
  'quickSwitcher.navigate': '移動',
  'quickSwitcher.open': '開く',
  'quickSwitcher.close': '閉じる',
  'pasteDialog.title': 'テキストを貼り付け',
  'pasteDialog.hint': 'プロジェクトフォルダーに保存されます。任意の名前を付けてください。',
  'pasteDialog.fileNameLabel': 'ファイル名',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'コンテンツ',
  'pasteDialog.contentPlaceholder': '何でも貼り付け…',
  'pasteDialog.save': '保存',
  'pasteDialog.cancel': 'キャンセル',
  'sketch.save': 'スケッチを保存',
  'sketch.cancel': 'キャンセル',
  'sketch.saving': '保存中…',
  'sketch.saved': '保存済み',
  'sketch.tooltipDirty': '未保存の変更があります',
  'sketch.tooltipClean': '保存済み',
  'fileViewer.empty': 'ファイルを選択して表示します。',
  'fileViewer.loading': '読み込み中…',
  'fileViewer.exportPptx': 'PPTX としてエクスポート',
  'fileViewer.openInNewTab': '新しいタブで開く',
  'fileViewer.copyPath': 'パスをコピー',
  'fileViewer.copied': 'コピーしました！',
  'fileViewer.share': '共有',
  'fileViewer.binaryMeta': 'バイナリ · {size}',
  'fileViewer.binaryNote':
    'バイナリファイル（{size} バイト）。ダウンロードするかディスクから開いて確認してください。',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'ドキュメント',
  'fileViewer.presentationMeta': 'プレゼンテーション',
  'fileViewer.spreadsheetMeta': 'スプレッドシート',
  'fileViewer.previewUnavailable': 'プレビューは利用できません。ファイルをダウンロードするか開いて確認してください。',
  'fileViewer.download': 'ダウンロード',
  'fileViewer.open': '開く',
  'fileViewer.imageMeta': '画像 · {size}',
  'fileViewer.reactMeta': 'React コンポーネント · {size}',
  'fileViewer.sketchMeta': 'スケッチ · {size}',
  'fileViewer.markdownStreamingMeta': 'ストリーミングプレビュー中…',
  'fileViewer.markdownErrorMeta': 'プレビューが不完全な場合があります（生成エラー）。',
  'fileViewer.markdownStreamingStatus': 'ストリーミング中… 部分的な Markdown を表示しています。',
  'fileViewer.markdownErrorStatus': '生成エラー。最後に利用可能なコンテンツを表示しています。',
  'fileViewer.videoMeta': '動画 · {size}',
  'fileViewer.audioMeta': '音声 · {size}',
  'fileViewer.reload': '再読み込み',
  'fileViewer.reloadDisk': 'ディスクから再読み込み',
  'fileViewer.copy': 'コピー',
  'fileViewer.copyTitle': 'ファイルの内容をコピー',
  'fileViewer.saveDisabled': '保存（読み取り専用ビューアー）',
  'fileViewer.save': '保存',
  'fileViewer.preview': 'プレビュー',
  'fileViewer.source': 'ソース',
  'fileViewer.tweaks': '調整',
  'fileViewer.tweaksUnavailable': 'このアーティファクトには調整パネルがありません',
  'fileViewer.jsxModuleTitle': '単独プレビューはありません',
  'fileViewer.jsxModuleBody': 'このファイルは別のページから読み込まれるコンポーネントモジュールです。',
  'fileViewer.jsxModuleCta': '表示するページを開いてください:',
  'fileViewer.comment': 'コメント',
  'fileViewer.edit': '編集',
  'fileViewer.draw': '描画',
  'manualEdit.layers': "Layers",
  'manualEdit.editableCount': "{count} editable",
  'manualEdit.hiddenBadge': "Hidden",
  'manualEdit.title': "Manual editor",
  'manualEdit.selectLayer': "Select a layer",
  'manualEdit.empty': "Click an element in the preview or choose a layer.",
  'manualEdit.noEditableLayers': "No editable layers found.",
  'manualEdit.noClass': "no class",
  'manualEdit.tabsAria': "Manual edit tabs",
  'manualEdit.tabContent': "Content",
  'manualEdit.tabStyle': "Style",
  'manualEdit.tabAttributes': "Attributes",
  'manualEdit.tabHtml': "Html",
  'manualEdit.tabSource': "Source",
  'manualEdit.attributesJson': "Attributes JSON",
  'manualEdit.selectedHtml': "Selected element HTML",
  'manualEdit.fullSource': "Full artifact source",
  'manualEdit.applyContent': "Apply Content",
  'manualEdit.applyStyle': "Apply Style",
  'manualEdit.applyAttributes': "Apply Attributes",
  'manualEdit.applyHtml': "Apply HTML",
  'manualEdit.applySource': "Apply Source",
  'manualEdit.invalidAttributes': "Invalid attributes JSON.",
  'manualEdit.changes': "Changes",
  'manualEdit.undo': "Undo",
  'manualEdit.redo': "Redo",
  'manualEdit.noChanges': "No manual edits yet.",
  'manualEdit.imageUrl': "Image URL",
  'manualEdit.altText': "Alt text",
  'manualEdit.label': "Label",
  'manualEdit.text': "Text",
  'manualEdit.href': "Href",
  'manualEdit.textColor': "Text color",
  'manualEdit.background': "Background",
  'manualEdit.fontSize': "Font size",
  'manualEdit.weight': "Weight",
  'manualEdit.align': "Align",
  'manualEdit.padding': "Padding",
  'manualEdit.margin': "Margin",
  'manualEdit.radius': "Radius",
  'manualEdit.border': "Border",
  'manualEdit.width': "Width",
  'manualEdit.minHeight': "Min height",
  'fileViewer.zoomOut': 'ズームアウト',
  'fileViewer.zoomIn': 'ズームイン',
  'fileViewer.resetZoom': 'ズームをリセット',
  'fileViewer.viewportAria': 'Preview viewport',
  'fileViewer.viewportDesktop': 'Desktop',
  'fileViewer.viewportDesktopTitle': 'Full-width desktop preview',
  'fileViewer.viewportTablet': 'Tablet',
  'fileViewer.viewportTabletTitle': 'Tablet preview at 820 × 1180 (modern portrait baseline)',
  'fileViewer.viewportMobile': 'Mobile',
  'fileViewer.viewportMobileTitle': 'Mobile preview at 390 × 844',
  'fileViewer.reloadAria': '再読み込み',
  'fileViewer.previousSlide': '前のスライド',
  'fileViewer.nextSlide': '次のスライド',
  'fileViewer.slideNavAria': 'スライドナビゲーション',
  'fileViewer.present': 'プレゼン',
  'fileViewer.presentInTab': 'このタブで',
  'fileViewer.presentFullscreen': 'フルスクリーン',
  'fileViewer.presentNewTab': '新しいタブ',
  'fileViewer.exitPresentation': 'プレゼンを終了',
  'fileViewer.shareLabel': "共有",
  'fileViewer.exportPdf': 'PDFとしてエクスポート',
  'fileViewer.exportPdfAllSlides': 'PDFとしてエクスポート（全スライド）',
  'fileViewer.exportPptxBusy': '現在のターンが終わるまでお待ちください。',
  'fileViewer.exportPptxHint':
    'エージェントにこのデザインを PPTX に変換するようリクエストを送信します。',
  'fileViewer.exportPptxNa': 'ここでは PPTX エクスポートは利用できません。',
  'fileViewer.exportZip': '.zip としてダウンロード',
  'fileViewer.exportHtml': 'スタンドアロン HTML としてエクスポート',
  'fileViewer.exportMd': 'Markdown としてエクスポート',
  'fileViewer.exportImage': '画像としてエクスポート',
  'fileViewer.exportImageFailed': '画像のキャプチャに失敗しました。再試行するか、ブラウザのスクリーンショット機能をご利用ください。',
  'fileViewer.exportJsx': 'JSX としてエクスポート',
  'fileViewer.exportReactHtml': 'プレビューを HTML としてエクスポート',
  'fileViewer.saveAsTemplate': 'テンプレートとして保存…',
  'fileViewer.savingTemplate': 'テンプレートを保存中…',
  'fileViewer.savedTemplate': '"{name}" として保存しました',
  'fileViewer.savedTemplateFail': 'テンプレートを保存できませんでした — もう一度試してください。',
  'fileViewer.templateNamePrompt': 'テンプレート名',
  'fileViewer.templateNameDefault': '無題のテンプレート',
  'fileViewer.templateDescPrompt':
    '短い説明（省略可 — このテンプレートの使いどころは？）',
  'fileViewer.deployToVercel': 'Vercel にデプロイ',
  'fileViewer.redeployToVercel': '再デプロイ',
  'fileViewer.deployingToVercel': 'Vercel にデプロイ中…',
  'fileViewer.deployProviderLabel': 'プロバイダー',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '{provider} にデプロイ',
  'fileViewer.redeployToProvider': '{provider} に再デプロイ',
  'fileViewer.deployingToProvider': '{provider} にデプロイ中…',
  'fileViewer.preparingPublicLink': '公開リンクを準備中…',
  'fileViewer.copyDeployLink': 'リンクをコピー',
    'fileViewer.deployModalTitle': 'デプロイ',
  'fileViewer.deployModalSubtitle': '選択したプロバイダーのアカウントを使用して、この HTML プレビューをデプロイします。',
  'fileViewer.vercelToken': 'Vercel トークン',
  'fileViewer.vercelTokenGetLink': 'Vercel トークンを取得',
  'fileViewer.vercelTokenPlaceholder': 'Vercel トークンを貼り付け',
  'fileViewer.vercelTokenReuseHint': '保存済みトークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.vercelTokenRequired': '最初に Vercel トークンを入力して保存してください。',
  'fileViewer.cloudflareApiToken': 'Cloudflare API トークン',
  'fileViewer.cloudflareApiTokenGetLink': 'Cloudflare API トークンを取得',
  'fileViewer.cloudflareApiTokenPlaceholder': 'Cloudflare API トークンを貼り付け',
  'fileViewer.cloudflareApiTokenReuseHint': '保存済みの Cloudflare API トークンが使用されます。新しいトークンを入力すると置き換えられます。',
  'fileViewer.cloudflareApiTokenRequired': '最初に Cloudflare API トークンを入力して保存してください。',
  'fileViewer.cloudflareApiTokenScopeHint': 'Pages Edit is required for deploys. Zone Read is required to list domains. DNS Edit is only needed when binding a custom domain.',
  'fileViewer.vercelTeamId': 'チーム ID',
  'fileViewer.vercelTeamSlug': 'チームスラッグ',
  'fileViewer.cloudflareAccountId': 'アカウント ID',
  'fileViewer.cloudflareAccountIdHint': '必須です。Cloudflare ダッシュボードでアカウント ID を確認できます。',
  'fileViewer.cloudflareAccountIdRequired': '最初に Cloudflare Account ID を入力して保存してください。',
  'fileViewer.cloudflareZoneLabel': 'Domain',
  'fileViewer.cloudflareZonePlaceholder': 'Save Cloudflare settings to load domains',
  'fileViewer.cloudflareZoneRequired': 'Select a Cloudflare domain first.',
  'fileViewer.cloudflareZonesLoading': 'Loading Cloudflare domains…',
  'fileViewer.cloudflareZonesRefresh': 'Refresh domains',
  'fileViewer.cloudflareZonesLoadFailed': 'Could not load Cloudflare domains.',
  'fileViewer.cloudflareZonesEmpty': 'No active full Cloudflare domains were found for this account.',
  'fileViewer.cloudflareDomainPrefixLabel': 'Subdomain prefix',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'Use one DNS label only: lowercase letters, numbers, and hyphens.',
  'fileViewer.cloudflareHostnamePreview': 'Custom domain preview: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'Optional: choose a Cloudflare domain and prefix to bind a custom subdomain. pages.dev will still be available.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'Custom domain',
  'fileViewer.optional': '省略可',
  'fileViewer.vercelPreviewOnly': 'デプロイは現在 Preview のみです。',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages は Direct Upload を使用します。',
  'fileViewer.savingConfig': '保存中…',
  'fileViewer.deployConfigSaveFailed': 'Vercel の設定を保存できませんでした。',
  'fileViewer.deployFailed': 'デプロイに失敗しました。Vercel の設定を確認して再試行してください。',
  'fileViewer.deployProviderConfigSaveFailed': '{provider} の設定を保存できませんでした。',
  'fileViewer.deployProviderFailed': '{provider} のデプロイに失敗しました。設定を確認して再試行してください。',
  'fileViewer.deployResultLabel': 'デプロイ URL',
  'fileViewer.deployLinkReady': '準備完了',
  'fileViewer.deployLinkPreparingLabel': '公開リンク準備中',
  'fileViewer.deployLinkDelayed': 'サイトはデプロイされました。プロバイダーが公開リンクを準備中です。',
  'fileViewer.deployLinkFailed': 'カスタムドメインに失敗しました',
  'fileViewer.deployLinkProtectedLabel': 'デプロイ保護が有効',
  'fileViewer.deployLinkProtected': 'サイトはデプロイされましたが、このプレビューリンクには認証が必要です。Deployment Protection を無効にするか、カスタムドメインを使用してください。',
  'fileViewer.retryLink': '今すぐ再試行',

  'questionForm.submit': '送信',
  'questionForm.skip': 'スキップ',
  'questionForm.locked': '回答済み',

  'conv.switch': '会話を切り替え',
  'conv.label': '会話',
  'conv.heading': '会話',
  'conv.new': '+ 新規',
  'conv.empty': 'まだ会話がありません。',
  'conv.untitled': '無題の会話',
  'conv.renameTooltip': 'ダブルクリックで名前を変更',
  'conv.delete': '会話を削除',
  'conv.deleteConfirm': '"{title}" を削除しますか？メッセージも削除されます。',

  'agentPicker.label': 'エージェント',
  'agentPicker.modeChoose': '実行モードを選択',
  'agentPicker.localCli': 'ローカル CLI',
  'agentPicker.daemonOff': 'デーモン停止中',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': '検出されたコードエージェント CLI を選択',
  'agentPicker.noAgents': 'PATH 上にエージェントなし',
  'agentPicker.notInstalled': '未インストール',
  'agentPicker.rescan': 'エージェントのローカル PATH を再スキャン',

  'tool.openInTab': '{name} をタブで開く',
  'tool.open': '開く',
  'tool.todos': 'Todos',
  'tool.askQuestion': '質問',
  'tool.askQuestionSubmit': '送信',
  'tool.askQuestionPending': '回答をお待ちしています',
  'tool.askQuestionAnswered': '回答済み',
  'tool.todosExpand': 'タスクを表示',
  'tool.todosCollapse': 'タスクを非表示',
  'tool.todosDone': '完了',
  'tool.todosDismiss': 'タスクリストを閉じる',
  'tool.write': '書き込み',
  'tool.edit': '編集',
  'tool.read': '読み取り',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'フェッチ',
  'tool.search': '検索',
  'tool.lines': '{n} 行',
  'tool.changeSingular': '変更',
  'tool.changePlural': '変更',
  'tool.in': '{path} 内',
  'tool.hide': '隠す',
  'tool.output': '出力',
  'tool.running': '実行中…',
  'tool.error': 'エラー',
  'tool.done': '完了',

  'assistant.role': 'アシスタント',
  'assistant.workingLabel': '作業中',
  'assistant.doneLabel': '完了',
  'assistant.feedbackPrompt': 'フィードバック',
  'assistant.feedbackPositive': '役に立った',
  'assistant.feedbackNegative': '役に立たなかった',
  'assistant.feedbackReasonTitle': 'Tell us why',
  'assistant.feedbackReasonPositiveMatched': 'Understood my request',
  'assistant.feedbackReasonPositiveVisual': 'Looks good',
  'assistant.feedbackReasonPositiveUseful': 'Useful structure',
  'assistant.feedbackReasonPositiveEasy': 'Easy to keep editing',
  'assistant.feedbackReasonPositiveDesignSystem': 'Followed the design system',
  'assistant.feedbackReasonNegativeMissed': 'Missed my request',
  'assistant.feedbackReasonNegativeVisual': 'Visual quality needs work',
  'assistant.feedbackReasonNegativeIncomplete': 'Incomplete output',
  'assistant.feedbackReasonNegativeHard': 'Hard to use',
  'assistant.feedbackReasonNegativeDesignSystem': 'Did not follow the design system',
  'assistant.feedbackReasonOther': 'Other',
  'assistant.feedbackReasonPlaceholder': 'Add a short note...',
  'assistant.feedbackReasonSubmit': 'Submit',
  'assistant.emptyResponseLabel': 'No output',
  'assistant.emptyResponseMessage': 'The provider ended the request without returning text or an artifact. Try another model or provider, check quota, or retry.',
  'assistant.unfinishedLabel': '未完了の作業があります',
  'assistant.unfinishedSummary': '{n} 件のタスクが残っています',
  'assistant.unfinishedMore': '+{n} 件',
  'assistant.continueRemaining': '残りのタスクを続ける',
  'assistant.outTokens': '{n} 出力',
  'assistant.producedFiles': 'このターンのファイル',
  'assistant.openFile': '開く',
  'assistant.downloadFile': 'ダウンロード',
  'assistant.thinking': '考え中',
  'assistant.systemReminder': 'システムリマインダー',
  'assistant.waitingFirstOutput': '最初の出力を待っています',
  'assistant.statusBootingAgent': 'エージェントを起動中',
  'assistant.statusStarting': '開始中',
  'assistant.statusRequesting': 'リクエストを送信中',
  'assistant.statusThinking': '考え中',
  'assistant.statusStreaming': 'ストリーミング中',
  'assistant.slowHint':
    '通常より時間がかかっています。フォームは通常 5〜10 秒で表示されます — 停止して言い換えることもできます。',
  'assistant.verbEditing': '編集中',
  'assistant.verbWriting': '生成中',
  'assistant.verbReading': '読み取り中',
  'assistant.verbSearching': '検索中',
  'assistant.verbRunning': '実行中',
  'assistant.verbTodos': 'Todos',
  'assistant.verbFetching': 'フェッチ中',
  'assistant.verbCalling': '呼び出し中',

  'qf.answered': '回答済み',
  'qf.choose': '選択…',
  'qf.required': '必須',
  'qf.lockedSubmitted':
    '回答を送信しました — エージェントがセッション終了まで参照します。',
  'qf.lockedPrev': 'このフォームは前のターンのものです。',
  'qf.hint':
    '適切なものを選んでください。気にしない任意フィールドはスキップしてください — エージェントが適切なデフォルト値を使用します。',
  'qf.submitDefault': '回答を送信',
  'qf.submitDisabledTitle': '最初に必須フィールドを入力してください',
  'qf.submitTitle': '回答を送信',
  'qf.cardSelected': '選択済み',
  'qf.cardRefs': '参照:',
  'qf.cardSampleText': 'The quick brown fox · 0123',

  'sketch.toolSelect': '選択（操作なし）',
  'sketch.toolPen': 'ペン',
  'sketch.toolText': 'テキスト',
  'sketch.toolRect': '四角形',
  'sketch.toolArrow': '矢印',
  'sketch.toolEraser': '消しゴム',
  'sketch.color': '色',
  'sketch.strokeSize': 'ストロークサイズ',
  'sketch.undo': '元に戻す',
  'sketch.clear': 'クリア',
  'sketch.close': '閉じる',
  'sketch.closeConfirm': 'スケッチを閉じて未保存の変更を破棄しますか？',
  'sketch.textPrompt': 'テキスト:',
  'sketch.textModalTitle': 'テキストを追加',

  'critiqueTheater.userFacingName': 'デザイン陪審',
  'critiqueTheater.roleDesigner': 'デザイナー',
  'critiqueTheater.roleCritic': '批評家',
  'critiqueTheater.roleBrand': 'ブランド',
  'critiqueTheater.roleA11y': 'アクセシビリティ',
  'critiqueTheater.roleCopy': 'コピー',
  'critiqueTheater.roundLabel': 'ラウンド {n} / {m}',
  'critiqueTheater.mustFix': '要修正 {n} 件',
  'critiqueTheater.composite': '総合スコア',
  'critiqueTheater.threshold': 'しきい値',
  'critiqueTheater.consensus': '合意',
  'critiqueTheater.interrupt': '中断',
  'critiqueTheater.interrupting': '中断中…',
  'critiqueTheater.interrupted': '中断済み',
  'critiqueTheater.interruptedSummary': 'ラウンド {round} で中断 · 最高総合 {composite}',
  'critiqueTheater.degradedHeading': 'この実行ではパネル無効',
  'critiqueTheater.degradedReasonMalformed': 'パネル出力の形式が不正です（パーサーが拒否）。',
  'critiqueTheater.degradedReasonOversize': 'パネル出力が安全なバイト予算を超えました。',
  'critiqueTheater.degradedReasonAdapter': 'アダプター {adapter} は批評プロトコルをサポートしていません。',
  'critiqueTheater.degradedReasonProtocol': 'アダプター {adapter} はサポート対象外のプロトコルバージョンを使用しています。',
  'critiqueTheater.degradedReasonMissingArtifact': '実行は完了しましたが最終成果物がありません。',
  'critiqueTheater.replay': 'リプレイ',
  'critiqueTheater.replaySpeed': 'リプレイ速度',
  'critiqueTheater.readOnly': '読み取り専用',
  'critiqueTheater.shippedSummary': 'ラウンド {round} で出荷 · 総合 {composite}',
  'critiqueTheater.shippedBadge': '出荷済み',
  'critiqueTheater.belowThresholdBadge': 'しきい値未達',
  'critiqueTheater.timedOutBadge': 'タイムアウト',
  'critiqueTheater.failedHeading': '実行に失敗しました',
  'critiqueTheater.failedReasonCliExit': 'エージェント CLI がパネル完了前に異常終了しました。',
  'critiqueTheater.failedReasonPerRoundTimeout': 'いずれかのラウンドが時間予算を超過しました。',
  'critiqueTheater.failedReasonTotalTimeout': '実行全体が時間予算を超過しました。',
  'critiqueTheater.failedReasonOrchestrator': 'オーケストレーターの内部エラー。',
  'critiqueTheater.transcriptEmpty': '再生できるトランスクリプトがありません。批評を実行して記録してください。',
  'critiqueTheater.transcriptLoading': 'トランスクリプトを読み込み中…',
  'critiqueTheater.transcriptError': 'トランスクリプトを読み込めませんでした: {error}',
  'critiqueTheater.replaySpeedPaused': '一時停止',
  'critiqueTheater.replaySpeedInstant': '即時',
  'critiqueTheater.replaySpeedLive': 'ライブ',
  'critiqueTheater.replaySpeedFast': '高速',
  'critiqueTheater.settingsNav': 'デザイン陪審',
  'critiqueTheater.settingsNavHint': 'エージェント実行中の 5 名パネルレビュー',
  'critiqueTheater.settingsEnabledLabel': 'エージェント実行中にデザイン陪審を表示',
  'critiqueTheater.settingsEnabledDescription':
    '有効にすると、エージェント生成中に 5 名のパネルレビューが並走し、出荷前に結果を採点します。いつでも中断できます。',
  'critiqueTheater.settingsEnabledProjectHint':
    'このプロジェクトに保存しました。今後の実行はサーバ側でデザイン陪審を通ります。',
  'critiqueTheater.settingsEnabledNoProjectHint':
    'サーバ側に保存するにはプロジェクトを開いてください。それまではブラウザ内の設定のみ変更されます。',

  'pet.title': 'ペット',
  'pet.tabBuiltIn': '組み込み',
  'pet.tabBuiltInHint': 'Open Design に同梱された厳選コンパニオン — 選んで迎え入れよう。',
  'pet.builtInEmpty': '組み込みペットを今は読み込めません。デーモンが復帰したらコミュニティタブを更新してください。',
  'pet.tabCustom': 'カスタム',
  'pet.tabCustomHint': '名前・絵文字・色・スプライトを自分で設定。',
  'pet.tabCommunity': 'コミュニティ',
  'pet.tabCommunityHint': 'Codex で孵ったペット — 養子に取るか AI で新しく作る。',
  'pet.tabsAria': 'ペットのソース',
  'pet.subtitle': 'ワークスペースに浮かぶ小さな相棒を迎えましょう。',
  'pet.navTitle': 'ペット',
  'pet.navHint': '迎える・カスタマイズ',
  'pet.adopt': '迎える',
  'pet.adoptedBadge': '迎え済み',
  'pet.adoptCallout': 'ペットを迎える',
  'pet.changePet': 'ペットを変更',
  'pet.wake': '呼び出す',
  'pet.tuck': 'しまう',
  'pet.wakeTitle': 'ペットを呼び出す — 浮かぶオーバーレイを表示。',
  'pet.tuckTitle': 'ペットをしまう — オーバーレイを非表示。',
  'pet.settingsTitle': 'ペット設定を開く',
  'pet.useCustom': 'マイペットを使う',
  'pet.customTitle': '自分で作る',
  'pet.customHint': '名前、アイコン、アクセントカラーを選ぶと、オーバーレイが即時に更新されます。',
  'pet.customGreetingPlaceholder': 'ペットからのあいさつ…',
  'pet.fieldName': '名前',
  'pet.fieldGlyph': 'アイコン',
  'pet.fieldGlyphHint': '絵文字 1 つが最適です（例：🐝、🦄、🐢）。',
  'pet.fieldGreeting': 'あいさつ',
  'pet.fieldAccent': 'アクセントカラー',
  'pet.fieldAccentCustom': 'カスタムカラー',
  'pet.fieldAccentDefault': 'デフォルトのアクセントカラー',
  'pet.overlayAria': 'ペットの相棒',
  'pet.spriteAria': '{name} — ドラッグで移動、クリックで会話',
  'pet.spriteTitle': '{name} からこんにちは！クリックで会話。',
  'pet.composerTitle': 'ペット — 呼び出す・しまう・選ぶ',
  'pet.composerMenuTitle': 'ペット',
  'pet.composerMenuHint': 'ヒント：/pet と入力で切替',
  'pet.composerOpenSettings': 'ペットを管理',
  'pet.welcomeTeaserTitle': 'ペットを迎える',
  'pet.welcomeTeaserBody': 'ワークスペースに浮かぶ小さな相棒です。',
  'pet.welcomeTeaserCta': '選ぶ',
  'pet.imageUpload': 'スプライトをアップロード',
  'pet.imageReplace': 'スプライトを差し替える',
  'pet.imageRemove': '絵文字に戻す',
  'pet.imageHintIdle': 'PNG / JPG / WebP / GIF / SVG に対応。スプライトシート？横長の帯をアップしてフレーム数を指定してください。',
  'pet.imageHintActive': 'アップしたスプライトを表示中。フレーム数を 1 より大きくすると横スプライトシートが動きます。',
  'pet.fieldFrames': 'フレーム数',
  'pet.fieldFramesHint': '1 = 静止。2 以上 = 横スプライトシート。',
  'pet.fieldFps': '速度 (fps)',
  'pet.fieldFpsHint': 'フレーム切替の速さ。',
  'pet.atlasImport': 'Codex スプライトを取り込む',
  'pet.atlasImportTitle': 'hatch-pet の 8x9 / 192x208 アトラス(PNG または WebP)を取り込みます。',
  'pet.atlasPickerTitle': 'アニメーション行を選択',
  'pet.atlasPickerHint': 'Codex ペットは 9 種類のアニメーション行を持っています。デフォルトはアトラス全体を保持し、ホバー・ドラッグ方向・長時間アイドルに応じて行が切り替わります。1 行だけにロックすることもできます。',
  'pet.atlasCancel': 'アトラスを破棄',
  'pet.atlasAdopt': 'この行に固定',
  'pet.atlasAdoptFull': 'アトラス全体を使う(アニメーション)',
  'pet.atlasAdoptFullTitle': 'すべての行を保持して、ホバー・ドラッグ方向・長時間アイドルに反応させます。',
  'pet.atlasAdoptRowTitle': 'ハイライト中の行だけをループするストリップに切り出します。',
  'pet.atlasActiveHint': 'アニメーションアトラス有効 — 操作(ホバー・ドラッグ・アイドル)に応じてペットが行を切り替えます。',
  'pet.atlasRow.idle': 'アイドル',
  'pet.atlasRow.running-right': '右に走る',
  'pet.atlasRow.running-left': '左に走る',
  'pet.atlasRow.waving': '手を振る',
  'pet.atlasRow.jumping': 'ジャンプ',
  'pet.atlasRow.failed': '失敗',
  'pet.atlasRow.waiting': '待機',
  'pet.atlasRow.running': '走る',
  'pet.atlasRow.review': 'レビュー',
  'pet.hatchTitle': 'AI で新しいペットを孵化',
  'pet.hatchHint': '同梱の hatch-pet スキルをチャットで実行して Codex 風のスプライトシートを生成し、ここから取り込んでください。',
  'pet.hatchConcept': 'ペットのコンセプト(任意)',
  'pet.hatchConceptPlaceholder': '例: セーターを着た小さなピクセル風の柴犬',
  'pet.hatchCopy': 'プロンプトをコピー',
  'pet.hatchCopied': 'コピー済み!',
  'pet.hatchFoot': 'スキルがペットを保存したら、ここに戻って「Codex スプライトを取り込む」を選んでください。',
  'pet.slashPopoverAria': 'スラッシュコマンド',
  'pet.slashPopoverTitle': 'コマンド',
  'pet.slashPopoverHint': '↑↓ で移動 · enter で選択 · esc で閉じる',
  'pet.slashPet': 'ペットを切替・採用、または設定を開く。',
  'pet.slashPetWake': '浮遊ペットを起こす。',
  'pet.slashPetTuck': 'ペットを一旦しまう。',
  'pet.slashHatch': 'hatch-pet スキルで Codex ペットを生成。',
  'pet.slashHatchArg': '<コンセプト>',
  'pet.slashSearch': 'OD research コマンドで Web 検索します。',
  'pet.slashSearchArg': '<検索クエリ>',
  'pet.codexTitle': '最近の孵化',
  'pet.codexSubtitle': 'hatch-pet スキルがパッケージしたペットがここに表示され、ワンクリックで採用できます。',
  'pet.codexSubtitleWithDir': '{dir} を hatch-pet スキルのパッケージのために走査中。',
  'pet.codexEmpty': '孵化したペットはまだありません。チャットで /hatch を入力して生成しましょう。',
  'pet.codexLoading': '孵化したペットを探しています…',
  'pet.codexRefresh': '更新',
  'pet.codexAdopt': '採用',
  'pet.codexAdopting': '採用中…',
  'pet.communitySync': 'コミュニティペットをダウンロード',
  'pet.communitySyncing': 'ダウンロード中…',
  'pet.communitySyncTitle': 'Codex Pet Share と j20 Hatchery の最新ペットを ~/.codex/pets/ に同期します。',
  'pet.communitySyncDone': '{wrote} 体の新しいペットを同期しました（合計 {total} 体）。',
  'pet.communitySyncFailed': '同期に失敗しました: {error}',
  'pet.codexBundled': '同梱',
  'pet.codexBundledTitle': 'Open Design に同梱 — ダウンロード不要。',

  'settings.notifications': '通知',
  'settings.notificationsHint': 'タスク完了時の効果音とデスクトップ通知',
  'settings.notifyCompletionSound': '完了サウンド',
  'settings.notifyCompletionSoundHint': '1ターン終了時に再生されます。既定ではオフです。',
  'settings.notifySuccessSound': '成功サウンド',
  'settings.notifyFailureSound': '失敗サウンド',
  'settings.notifyDesktop': 'デスクトップ通知',
  'settings.notifyDesktopHint': 'ウィンドウが非アクティブのときに送信されます。',
  'settings.notifyDesktopBlocked': 'ブラウザにブロックされています。サイト設定で許可してください。',
  'settings.notifyDesktopUnsupported': 'この環境ではデスクトップ通知に対応していません。',
  'settings.notifyTest': 'テスト送信',
  'settings.notifyTestSent': 'テスト通知を送信しました。バナーが出ない場合は、ブラウザとシステムの通知設定を確認してください。',
  'settings.notifyTestFailed': '通知の呼び出しに失敗しました。ブラウザとシステムの通知設定を確認してください。',
  'settings.notifySoundDing': 'ティン',
  'settings.notifySoundChime': 'チャイム',
  'settings.notifySoundTwoToneUp': '上昇2音',
  'settings.notifySoundPluck': 'プラック',
  'settings.notifySoundBuzz': 'ブザー',
  'settings.notifySoundTwoToneDown': '下降2音',
  'settings.notifySoundThud': 'ドスン',
  'settings.skills': 'スキル',
  'settings.skillsHint': 'エージェントがタスク中に呼び出せる機能スキル',
  'settings.skillsNew': '新規スキル',
  'settings.skillsEmpty': '左からスキルを選ぶか、新規作成してください。',
  'settings.skillsEdit': '編集',
  'settings.skillsDelete': '削除',
  'settings.skillsDeleteConfirm': '削除を確定',
  'settings.skillsName': '名前',
  'settings.skillsTriggers': 'トリガー（カンマ／改行区切り）',
  'settings.skillsDescription': '説明',
  'settings.skillsBody': 'SKILL.md 本文',
  'settings.skillsCreate': '作成',
  'settings.skillsSave': '保存',
  'settings.skillsSaving': '保存中…',
  'settings.skillsFiles': 'ファイル',
    'settings.skillsNoFiles': 'このスキルフォルダーにファイルはありません。',
  'settings.skillsNameRequired': 'スキル名は必須です。',
  'settings.skillsBodyRequired': 'スキルの内容は必須です。',
  'settings.designSystems': 'デザインシステム',
  'settings.designSystemsHint': 'エージェントが利用できるデザインシステムを管理',
  'settings.designSystemsInstalled': 'インストール済み',
  'settings.designSystemsAdd': 'デザインシステムを追加',
  'settings.designSystemsHiddenCount': '{count} 件をホームギャラリーから非表示',
  'settings.designSystemsShowAll': 'すべて表示',
  'settings.designSystemsShowHidden': '非表示を表示',
  'settings.designSystemsSource': 'ソース',
  'settings.designSystemsSourceLocal': 'ローカル',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsStructure': '構造',
  'settings.designSystemsModeHybrid': 'ハイブリッド',
  'settings.designSystemsModeNormalized': '正規化',
  'settings.designSystemsModeVerbatim': 'そのまま',
  'settings.designSystemsCraft': 'Craft',
  'settings.designSystemsCraftColor': 'カラー',
  'settings.designSystemsCraftAccessibility': 'アクセシビリティ',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': 'プロジェクトパス',
  'settings.designSystemsImportGithub': 'GitHub からインポート',
  'settings.designSystemsImportProject': 'プロジェクトからインポート',
  'settings.designSystemsImportedStatus': '{title} をインポートしました',
  'settings.designSystemsViewImported': 'インポートしたデザインシステムを表示',
  'settings.designSystemsCategory': 'カテゴリー',
  'settings.designSystemsAllCategories': 'すべてのカテゴリー',
  'settings.designSystemsShowInHomeGallery': 'ホームギャラリーに表示',
  'settings.librarySkills': 'スキル',
  'settings.libraryDesignSystems': 'デザインシステム',
  'settings.librarySearch': '検索...',
  'settings.libraryAll': 'すべて',
  'settings.libraryPreview': 'プレビュー',
  'settings.libraryPreviewClose': '閉じる',
  'settings.libraryLoading': '読み込み中...',
  'settings.libraryNoResults': '検索条件に一致する項目がありません。',
  'settings.libraryEnabled': '有効',
  'settings.libraryDisabled': '無効',
  'settings.connectorsNavHint': '外部システム接続',
  'settings.connectorsHint': 'このデバイスのコネクターとツールプロバイダー設定を管理します。',
  'settings.connectorsComposioApiKey': 'Composio API キー',
  'settings.connectorsSavedTitle': 'ローカル daemon に保存済み',
  'settings.connectorsSavedWithTail': '保存済み · ••••{tail}',
  'settings.connectorsSaved': '保存済み',
  'settings.connectorsGetApiKey': 'API キーを取得',
  'settings.connectorsReplaceKeyPlaceholder': '保存済みキーを置き換えるには新しいキーを貼り付け',
  'settings.connectorsApiKeyPlaceholder': 'Composio API キーを貼り付け',
  'settings.connectorsClear': 'クリア',
  'settings.connectorsClearConfirmTitle': '保存された Composio API キーを削除しますか？',
  'settings.connectorsClearConfirmBody': 'キーを削除すると、このワークスペースに紐づくすべての Composio コネクタが切断されます。接続中のアカウント、OAuth 認可、ツールへのアクセス権はすべて取り消されます。',
  'settings.connectorsClearConfirmContinue': '続行',
  'settings.connectorsClearFinalTitle': 'すべてのコネクタが切断されます',
  'settings.connectorsClearFinalBody': '元には戻せません。新しいキーを貼り付けたあと、各インテグレーションをイチから接続し直す必要があります。',
  'settings.connectorsClearFinalConfirm': 'キーを削除して切断',
  'settings.connectorsClearArming': '少々お待ちを\u2026',
  'settings.connectorsClearCancel': 'キャンセル',
  'settings.connectorsSaveKey': "キーを保存",
  'settings.connectorsSaveKeyTitle': "このキーをローカルの daemon に送信",
  'settings.connectorsKeySaving': "保存中…",
  'settings.connectorsKeySaved': "保存完了 ✓",
  'settings.connectorsKeyError': "キーを保存できませんでした。ローカルの daemon が起動しているか確認して、もう一度お試しください。",
  'settings.connectorsHelpSaved': 'キーは下のカタログを有効にし、ローカル daemon に保持されます。置き換えるには新しいキーを貼り付け、削除するにはクリアしてください。',
  'settings.connectorsHelpUnsaved': "未保存の変更があります — 「キーを保存」をクリックすると、この資格情報がローカル daemon に保存され、下のカタログが解除されます。",
  'settings.connectorsHelpEmpty': '下のカタログを有効にするにはキーを追加してください。キーは daemon にローカル保存され、環境変数経由で送信されることはありません。',
  'settings.connectorsLoadingSavedKey': 'ローカル daemon に保存されたキーを確認しています…',
  'settings.autosaveSaving': "保存中…",
  'settings.autosaveSaved': "すべての変更を保存しました",
  'settings.autosaveError': "変更を保存できませんでした。ローカル daemon がオフラインの可能性があります。",
  'settings.libraryToggleLabel': '切り替え',
  // Memory (auto-extracted personalization saved as on-disk markdown)
  'settings.memory': 'メモリ',
  'settings.memoryHint': 'チャットから自動抽出された個人情報',
  'settings.memoryDescription': 'あなたの好みや背景情報を自動的に抽出し、Markdown ファイルとして保存します。次回以降のチャットに自動で反映されます。',
  'settings.memoryEnabled': '有効',
  'settings.memoryDisabled': '無効',
  'settings.memoryEnableLabel': 'メモリの挿入を有効にする',
  'settings.memoryDisabledBanner': 'メモリは現在オフです。既存の事実はディスク上に残りますが、新しい会話には注入されず、新しい情報の抽出も行われません。',
  'settings.memoryNew': '新規メモリ',
  'settings.memoryEdit': '編集',
  'settings.memoryDelete': '削除',
  'settings.memoryPreview': 'プレビュー',
  'settings.memoryEmpty': 'まだメモリはありません。',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': '名前',
  'settings.memoryDesc': '1 行の説明',
  'settings.memoryBody': 'メモリ本文（Markdown 対応）',
  'settings.memoryBodyHint': 'ルール本体を先に書き、Why と How to apply の 2 行を続けて。',
  'settings.memoryStartersLabel': 'Need a starting point? Click to fill the form:',
  'settings.memoryStarterUserName': 'My role',
  'settings.memoryStarterUserDesc': 'I am a frontend engineer working on a SaaS design tool',
  'settings.memoryStarterUserBody': '- Role: senior frontend engineer\n- Stack: React, TypeScript, Vite\n- Domain: design / collaboration tools\n- Timezone: GMT+8 (Asia/Shanghai)\n\nWhen to apply: any chat — frame examples around web frontend.',
  'settings.memoryStarterFeedbackName': 'UI preferences',
  'settings.memoryStarterFeedbackDesc': 'Dark mode, large body text, low information density',
  'settings.memoryStarterFeedbackBody': '- Theme: dark by default\n- Body text: ≥ 18px\n- Information density: prefer whitespace, fewer items per screen\n\nWhy: less eye strain during long sessions.\nWhen to apply: whenever you generate UI, web pages, or slides.',
  'settings.memoryStarterProjectName': 'Current project',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — chat-driven design editor',
  'settings.memoryStarterProjectBody': '- Goal: ship the chat-driven editor this quarter\n- Priorities: streaming render, local multimodal, offline-first\n- Stack: Next.js 16, Express daemon, SQLite\n\nWhen to apply: in any conversation about this project.',
  'settings.memorySaveHint': 'Not auto-saved — click Create / Save to apply.',
  'settings.memoryIndexSaveHint': 'Edits to the index are not auto-saved — click Save index to apply.',
  'settings.memoryIndexUnsaved': 'Unsaved changes',
  'settings.memoryFlashCreated': '✓ Memory created',
  'settings.memoryFlashSaved': '✓ Memory saved',
  'settings.memoryFlashDeleted': '✓ Memory deleted',
  'settings.memoryFlashIndexSaved': '✓ Index saved',
  'settings.memoryFlashPathCopied': '✓ パスをコピーしました',
  'settings.memoryNameLabel': 'Title',
  'settings.memoryTypeLabel': 'Type',
  'settings.memoryDescLabel': 'Description',
  'settings.memoryBodyLabel': 'Content',
  'settings.memoryTypeUser': 'ユーザー',
  'settings.memoryTypeFeedback': 'フィードバック',
  'settings.memoryTypeProject': 'プロジェクト',
  'settings.memoryTypeReference': '参照',
  'settings.memoryIndex': 'MEMORY.md（索引）',
  'settings.memoryIndexSave': '索引を保存',
  'settings.memoryIndexReset': 'リセット',
  'settings.memoryToastChanged': 'メモリを更新しました',
  'settings.memoryToastClickHint': '表示',
  'settings.memoryAll': 'すべて',
  'settings.memoryExtractions': 'Extraction history',
  'settings.memoryExtractionsHint': 'Recent LLM-backed extraction attempts. Heuristic regex extraction always runs first; LLM extraction runs in the background after each turn.',
  'settings.memoryExtractionsEmpty': 'No extractions yet. The next chat turn will populate this list.',
  'settings.memoryExtractionsRefresh': 'Refresh',
  'settings.memoryExtractionsRefreshing': 'Refreshing…',
  'settings.memoryExtractionPhaseRunning': 'Running…',
  'settings.memoryExtractionPhaseSuccess': 'Success',
  'settings.memoryExtractionPhaseSkipped': 'Skipped',
  'settings.memoryExtractionPhaseFailed': 'Failed',
  'settings.memoryExtractionSkipNoProvider': 'No API key configured for LLM memory extraction.',
  'settings.memoryExtractionSkipDisabled': 'Memory is disabled.',
  'settings.memoryExtractionSkipEmpty': 'Empty user message — nothing to extract.',
  'settings.memoryExtractionSkipNoMatch': 'No regex pattern matched this turn.',
  'settings.memoryExtractionKindHeuristic': 'regex',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'media settings',
  'settings.memoryExtractionProposed': 'proposed',
  'settings.memoryExtractionWritten': 'written',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryNoProviderBannerTitle': 'LLM memory extraction is not running',
  'settings.memoryNoProviderBannerBody': 'No API key found for the memory extractor. Add an OpenAI key under Media providers, or set ANTHROPIC_API_KEY / OPENAI_API_KEY in the environment, to enable LLM-driven extraction. Heuristic regex extraction is still active.',
  'settings.memoryExtractionProviderOverride': 'memory settings',
  'settings.memoryExtractionDelete': 'Delete',
  'settings.memoryExtractionsClear': 'Clear',
  'settings.memoryExtractionsClearTitle': 'Clear all extraction history',
  'settings.libraryInstall': 'インストール',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'ローカルパス',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'インストール',
  'settings.libraryUninstall': 'アンインストール',
  'settings.libraryBuiltIn': '内蔵',
  'settings.libraryInstalled': 'インストール済み',
  'notify.successTitle': 'タスクが完了しました',
  'notify.failureTitle': 'タスクが失敗しました',
  'notify.successBody': '1ターンが終了しました。',
  'notify.failureBody': 'タスクはエラーで終了しました。',
  'updater.available': 'アップデートがあります',
  'updater.availableBody': 'Open Design {version} を利用できます。インストーラーを開く前にダウンロードします。',
  'updater.checking': 'アップデートを確認中',
  'updater.download': 'アップデートをダウンロード',
  'updater.downloading': 'アップデートをダウンロード中',
  'updater.downloadingPercent': 'アップデートをダウンロード中 {percent}%',
  'updater.done': '完了',
  'updater.failed': 'アップデートに失敗しました',
  'updater.installerOpenBody': 'インストーラーが開いています。更新を完了できるよう Open Design を終了しています。',
  'updater.installerOpened': 'インストーラーを開きました',
  'updater.later': '後で',
  'updater.openFailedFallback': 'インストーラーを開けませんでした。',
  'updater.openInstaller': '更新をインストール',
  'updater.opening': 'インストーラーを開いています...',
  'updater.quitButton': 'Open Design を終了',
  'updater.quitFailedBody': 'インストーラーは開いていますが、Open Design を終了できませんでした。アプリを置き換える前に Open Design を終了してください。',
  'updater.quitFailedTitle': '終了できませんでした',
  'updater.quitting': '終了しています...',
  'updater.ready': 'アップデート準備完了',
  'updater.readyGeneric': '新しいバージョンの準備ができました。Open Design を閉じてインストーラーを開きます。',
  'updater.readyVersion': 'Open Design {version} の準備ができました。Open Design を閉じてインストーラーを開きます。',
  'updater.upToDate': 'すでに最新バージョンです。',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': '自動化',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': '日次コネクターサマリー',
  'settings.orbit.lede': 'コネクターのアクティビティをスケジュールで収集し、結果を更新可能な live artifact として公開します。',
  'settings.orbit.statusOnTitle': '毎日のスケジュール実行はオンです',
  'settings.orbit.statusOffTitle': '毎日のスケジュール実行はオフです',
  'settings.orbit.statusActive': '有効',
  'settings.orbit.statusOff': 'オフ',
  'settings.orbit.runTitle': 'Orbit 実行を開始してライブ会話を開く',
  'settings.orbit.running': '実行中…',
  'settings.orbit.runOpen': '今すぐ実行',
  'settings.orbit.dailySummaryTitle': '日次サマリー',
  'settings.orbit.dailySummarySub': 'スケジュールされたローカル時刻に 1 日 1 回実行します。',
  'settings.orbit.on': 'オン',
  'settings.orbit.off': 'オフ',
  'settings.orbit.runTimeTitle': '実行時刻',
  'settings.orbit.runTimeSub': '既定は 08:00。保存すると daemon のスケジュールに適用されます。',
  'settings.orbit.runTimeAria': '毎日の Orbit 実行時刻',
  'settings.orbit.nextRun': '次の実行',
  'settings.orbit.nextRunScheduledAfterSave': '保存後にスケジュール',
  'settings.orbit.schedule': 'スケジュール',
  'settings.orbit.pausedManualOnly': '一時停止 — 手動実行のみ',
  'settings.orbit.templateTitle': 'プロンプトテンプレート',
  'settings.orbit.templateMissing': 'テンプレート {id} はインストールされていません。',
  'settings.orbit.templateMissingOption': '{id}（不足）',
  'settings.orbit.templateMissingInstall': 'プロンプトを制御するには Orbit skill をインストールしてください。',
  'settings.orbit.templateMissingPickAnother': 'ドロップダウンから別のテンプレートを選択してください。',
  'settings.orbit.templateResetTitle': '{id} にリセット',
  'settings.orbit.templateReset': 'リセット',
  'settings.orbit.templateHelp': 'skill で Orbit を制御します — 選択したテンプレートのサンプルプロンプトが各 Orbit 実行に挿入され、サマリーがそのテンプレートの形に従います。',
  'settings.orbit.templateAria': 'Orbit プロンプトテンプレート',
  'settings.orbit.templatesLoading': 'テンプレートを読み込み中…',
  'settings.orbit.templatesOptgroup': 'Orbit skill テンプレート',
  'settings.orbit.lastRun': '前回の実行',
  'settings.orbit.triggerManual': '手動',
  'settings.orbit.triggerScheduled': 'スケジュール済み',
  'settings.orbit.meterAria': 'チェック {checked} 件中、成功 {succeeded} 件、スキップ {skipped} 件、失敗 {failed} 件',
  'settings.orbit.countChecked': 'チェック済み',
  'settings.orbit.countSucceeded': '成功',
  'settings.orbit.countSkipped': 'スキップ',
  'settings.orbit.countFailed': '失敗',
  'settings.orbit.runError': 'Orbit を実行できませんでした。ローカル daemon が実行中で、コネクターが設定されていることを確認してください。',
  'settings.orbit.gateAriaLabel': "Orbit を使うにはコネクタが必要です",
  'settings.orbit.gateEyebrow': "セットアップが必要",
  'settings.orbit.gateTitle': "ツールを接続して Orbit を動かしましょう",
  'settings.orbit.gateBody': "Orbit はコネクタの活動を要約します。まだ何も接続されていません — 少なくとも 1 つの連携を追加すると、Orbit が報告できるようになります。",
  'settings.orbit.gateBodyNoKey': "Orbit はコネクタの活動を要約し、コネクタは Composio を通して動作します。コネクタ画面で Composio API キーを追加すると、カタログが解放され最初の連携を選べます。",
  'settings.orbit.gateAction': "コネクタを開く",
  'settings.orbit.gateActionNoKey': "Composio を設定",
  'settings.orbit.gateLoading': "コネクタを確認中…",
  'settings.orbit.controlsLockedBadge': "ロック中",
  'settings.orbit.controlsLockedHint': "ツールを接続すると、Orbit のスケジュールとテンプレート設定が有効になります。",
  'settings.orbit.artifactKickerLive': 'live artifact',
  'settings.orbit.artifactKickerLegacy': 'レガシーサマリー',
  'settings.orbit.artifactTitle': '日次 Orbit アクティビティサマリー',
  'settings.orbit.artifactMetaLive': 'コネクターアクティビティから生成された更新可能な HTML artifact。',
  'settings.orbit.artifactMetaLegacy': 'live artifact サポートが有効になる前に生成されました — 公開するには Orbit をもう一度実行してください。',
  'settings.orbit.copyMarkdownTitle': 'Markdown サマリーをクリップボードにコピー',
  'settings.orbit.copied': 'コピー済み',
  'settings.orbit.copy': 'コピー',
  'settings.orbit.openArtifact': 'artifact を開く',
  'settings.orbit.sourceMarkdown': 'ソース Markdown',
  'liveArtifact.viewer.tabPreview': 'プレビュー',
  'liveArtifact.viewer.tabCode': 'コード',
  'liveArtifact.viewer.tabData': 'データ',
  'liveArtifact.viewer.tabRefreshHistory': '更新履歴',
  'liveArtifact.viewer.dataEmpty': 'data.json キャッシュはありません。',
  'liveArtifact.viewer.code.templateHeading': 'テンプレート HTML',
  'liveArtifact.viewer.code.renderedHeading': 'レンダリング済み HTML',
  'liveArtifact.viewer.code.templateHelp': 'data.json と共にプレビュー生成に使われる編集可能なテンプレートです。',
  'liveArtifact.viewer.code.renderedHelp': 'プレビューで現在読み込まれている生成済み index.html です。',
  'liveArtifact.viewer.code.variantAria': 'コードの種類',
  'liveArtifact.viewer.code.variantTemplate': 'テンプレート',
  'liveArtifact.viewer.code.variantRendered': 'レンダリング済み',
  'liveArtifact.viewer.code.loading': 'コードを読み込み中…',
  'liveArtifact.viewer.code.unavailable': 'コードはまだ利用できません。',
  'liveArtifact.viewer.code.empty': 'このコードファイルは空です。',
  // Diagnostics export
  'diagnostics.exportTitle': '診断情報をエクスポート',
  'diagnostics.exportButton': '診断情報をエクスポート',
  'diagnostics.exportHint': '最近のアプリログとマシン情報を zip にまとめて、チームに共有できるようにします。',
  'diagnostics.exporting': 'エクスポート中…',
  'diagnostics.exportSuccess': '診断情報を {path} に保存しました',
  'diagnostics.exportFailed': '診断情報のエクスポートに失敗しました: {message}',
};
